import styled from 'styled-components';

export const Container = styled.button`
  background: ${({ theme }) => theme.colors.BUTTON_BG};
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.8rem;
  padding: 1.5rem 2rem;
  font-size: 1.4rem;
  transition: all 0.5s ease;
  color: ${({ theme }) => theme.colors.BUTTON_TEXT} !important;
  cursor: pointer;

  @media (max-width: 1024px) {
    font-size: 1rem;
    padding: 1rem;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.BUTTON_BG_HOVER};
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.BUTTON_TEXT_HOVER};
  }
`;
